import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { GroupedOffer } from "../types";
import api from "../../../../api/axios";
import { toast } from "react-toastify";

type Props = {
  open: boolean;
  onClose: () => void;
  offer: GroupedOffer;
  onOffersDeleted: (ids: string[]) => void;
};

const OfferDeleteModal: React.FC<Props> = ({
                                             open,
                                             onClose,
                                             offer,
                                             onOffersDeleted,
                                           }) => {
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    setLoading(true);

    const ids = offer.offers.map((o) => o.id);

    try {
      await toast.promise(
          api.post(`/on-sale/remove-offers`, ids),
          {
            pending: "Deleting offers...",
            success: "Offers deleted",
            error: "Delete failed",
          }
      );

      onOffersDeleted(ids);
      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
      <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
        <div className="relative">
          <DialogTitle>Delete Offer</DialogTitle>
          <IconButton onClick={onClose} className="!absolute right-3 top-3">
            <CloseIcon />
          </IconButton>
        </div>

        <DialogContent>
          Do you really want to delete all {offer.offers.length} offers for this
          item?
        </DialogContent>

        <DialogActions>
          <Button
              className="text-gray-700 dark:text-gray-200"
              onClick={onClose}
              disabled={loading}
          >
            Cancel
          </Button>
          <Button
              color="error"
              variant="contained"
              onClick={handleDelete}
              disabled={loading}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
  );
};

export default OfferDeleteModal;
